import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { updateProfile } from "../store/slices/authSlice";
import toast from "react-hot-toast";

const Profile: React.FC = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const [firstName, setFirstName] = useState(user?.first_name || "");
  const [lastName, setLastName] = useState(user?.last_name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [editing, setEditing] = useState(false);

  if (!user) {
    return (
      <div className="text-center py-12 text-gray-500">No user info found.</div>
    );
  }

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(
      updateProfile({ first_name: firstName, last_name: lastName, phone })
    );
    setEditing(false);
    toast.success("Profile updated!");
  };

  return (
    <div className="max-w-xl mx-auto py-8 px-4">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
        Profile
      </h1>
      <form
        onSubmit={handleSave}
        className="bg-white rounded-lg shadow p-6 space-y-6"
      >
        <div className="flex flex-col gap-4">
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              First Name
            </label>
            <input
              type="text"
              className="border rounded px-3 py-2 w-full"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              disabled={!editing}
            />
          </div>
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Last Name
            </label>
            <input
              type="text"
              className="border rounded px-3 py-2 w-full"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              disabled={!editing}
            />
          </div>
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Email
            </label>
            <input
              type="email"
              className="border rounded px-3 py-2 w-full bg-gray-100"
              value={user.email}
              disabled
            />
          </div>
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Phone
            </label>
            <input
              type="text"
              className="border rounded px-3 py-2 w-full"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              disabled={!editing}
            />
          </div>
          <div>
            <label className="block text-gray-700 font-semibold mb-1">
              Role
            </label>
            <input
              type="text"
              className="border rounded px-3 py-2 w-full bg-gray-100"
              value={user.role}
              disabled
            />
          </div>
        </div>
        <div className="flex gap-4 mt-4">
          {editing ? (
            <>
              <button type="submit" className="btn-primary px-6 py-2">
                Save
              </button>
              <button
                type="button"
                className="border border-gray-300 px-6 py-2 rounded-lg text-gray-700 hover:bg-gray-100"
                onClick={() => {
                  setEditing(false);
                  setFirstName(user.first_name);
                  setLastName(user.last_name);
                  setPhone(user.phone || "");
                }}
              >
                Cancel
              </button>
            </>
          ) : (
            <button
              type="button"
              className="btn-primary px-6 py-2"
              onClick={() => setEditing(true)}
            >
              Edit Profile
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Profile;
